import {store} from '../../../store';

export async function uploadPOCTool(Obj) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');
  const response = await fetch(`/api/AdminPanel`, {
    method: 'POST',
    headers,
    body: JSON.stringify(Obj),
  }).catch(err => {
    console.log(err);
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.text();
}

export async function uploadSuperPOCTools(Obj) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');
  const response = await fetch(`/api/AdminPanel/CreateSuperPOCTools`, {
    method: 'POST',
    headers,
    body: JSON.stringify(Obj),
  }).catch(err => {
    console.log(err);
  });
  if (!response.ok) {
    throw response.status;
  }
  return true;
}

export async function updatePOCTool(poctool) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');
  const response = await fetch(`/api/AdminPanel/${poctool.id}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(poctool),
  }).catch(err => {
    console.log(err);
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.text();
}

export async function updateSuperPOCTool(poctool) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');
  const response = await fetch(
    `/api/AdminPanel/EditSuperPOCTools/${poctool.id}`,
    {
      method: 'PUT',
      headers,
      body: JSON.stringify(poctool),
    },
  ).catch(err => {
    console.log(err);
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.text();
}

export async function deletePOCTool(id: string) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');
  const response = await fetch(`/api/AdminPanel/${id}`, {
    method: 'DELETE',
    headers,
  }).catch(err => {
    console.log(err);
  });
  if (!response.ok) {
    throw response.status;
  }
  return true;
}

export async function loadPOCToolSummaries() {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');

  const response = await fetch(`/api/AdminPanel`, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.json();
}

export async function publishPOCTools(id: string) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');

  const response = await fetch(`/api/AdminPanel/Publish`, {
    method: 'POST',
    headers,
    body: JSON.stringify({id: id}),
  });
  if (!response.ok) {
    throw response.status;
  }
  return true;
}

export async function unPublishPOCTools(id: string) {
  const jwtToken = store.getState().login.token;
  const headers = new Headers();
  headers.append('Authorization', 'Bearer ' + jwtToken);
  headers.append('Content-Type', 'application/json');

  const response = await fetch(`/api/AdminPanel/UnPublish`, {
    method: 'POST',
    headers,
    body: JSON.stringify({id: id}),
  });
  if (!response.ok) {
    throw response.status;
  }
  return true;
}
